export class Child {

  public id: number;
  public firstname: string;
  public lastname: string;
  public age: number;
  public allergy: string;

  public constructor(init?: Partial<Child>) {
    Object.assign(this, init);
  }
}
